import _ from 'lodash';
import apolloClient from '@/store/apollo';

import SlotsPaginatedGql from '@/extensions/event-manager/store/graphql/queries/SlotsPaginated.gql';

export default {
    // Queries
    fetchSlotsPaginated: (data) =>
        new Promise((resolve, reject) => {
            let filters = [];
            if (data.filters && data.filters.length) filters = data.filters;
            else for (let key in data.filters) filters.push(data.filters[key]);

            let cachePolicy = 'cache-first';
            if (process.env.VUE_APP_DISABLE_CACHE) cachePolicy = 'no-cache';

            apolloClient
                .query({
                    query: SlotsPaginatedGql,
                    fetchPolicy: cachePolicy,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 10),
                        order: _.get(data, 'order', 'start_at'),
                        direction: _.get(data, 'direction', 'asc'),
                        filters,
                    },
                })
                .then(({ data }) => resolve(data.EX_EVNT_SlotsPaginated))
                .catch((err) => reject(err));
        }),
};
